import { render, staticRenderFns } from "./newCompany.vue?vue&type=template&id=25497c3f&"
import script from "./newCompany.vue?vue&type=script&lang=js&"
export * from "./newCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports